import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../../../helpers/axios';


export function SecurityPinNumber({ open, onClose, id, type }) {
  const [pin, setPin] = useState("");

  // useEffect(() => {
  //   if (open) {
  //     setPin("");
  //   }
  // }, [open]);


  //validate pin
  const validatePin = (pin) => {
    if (!pin.trim()) {
      toast.error("Please enter PIN number");
      return false;
    }
    if (pin.trim().length < 4) {
      toast.error("Please enter 4 digit PIN number");
      return false;
    }
    return true;
  };

  //handleClick
  const handleLogin = async () => {
    if (!validatePin(pin)) return;

    console.log("handlelogin", id);
    try {
      const response = await axios.post('admin/verifypin', { security_pin: pin, id: id, type: type });
      console.log('response===', response)
      const { resp_code } = response.data;
      switch (resp_code) {
        case 200:
          toast.success("Security PIN verified successfully");
          window.open(
            'https://loan.ohhto.com/' + type + '?token=' + response.data.token,
            '_blank' 
          );
          break;
        case 400:
          toast.error("No expiry time found");
          break;
        case 404:
          toast.error("Invalid security PIN ");
          break;
        case 410:
          toast.error("The security PIN has expired");
          break;
        default:
          toast.error("Unexpected response from server");
      }

    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || "Failed to verify PIN"
      );
    }
  };

  return (
    <ThemeProvider theme={createTheme()}>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Security Pin Number</DialogTitle>
        <DialogContent>
          <div className="grid grid-cols-2 gap-4 mt-2">
            <div className="col-span-2">
              <input
                type="number"
                className="text-input w-full border border-gray-300 rounded px-3 py-2 mt-1"
                placeholder="Enter Security Pin"
                value={pin}
                maxLength={4}
                onChange={(e) => setPin(e.target.value)}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary" sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <Button
            onClick={handleLogin}
            variant="contained"
            sx={{
              textTransform: 'none',
              backgroundColor: '#0560fb',
              '&:hover': {
                backgroundColor: '#044bd1',
              },
            }}
          >
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
